interface IconProps {
  size?: number;
  className?: string;
}

export function SpotifyIcon({ size = 22, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      aria-label="Spotify"
    >
      <path d="M10 1.2A8.798 8.798 0 0 0 1.2 10 8.8 8.8 0 1 0 10 1.2zm3.478 13.302c-.173 0-.294-.066-.421-.143-1.189-.721-2.662-1.099-4.258-1.099-.814 0-1.693.097-2.61.285l-.112.028c-.116.028-.235.059-.326.059a.651.651 0 0 1-.661-.656c0-.373.21-.637.562-.703a14.037 14.037 0 0 1 3.152-.372c1.855 0 3.513.43 4.931 1.279.243.142.396.306.396.668a.655.655 0 0 1-.653.654zm.913-2.561c-.207 0-.343-.079-.463-.149-2.143-1.271-5.333-1.693-7.961-.993a3.742 3.742 0 0 0-.12.037c-.099.031-.191.062-.321.062a.786.786 0 0 1-.783-.788c0-.419.219-.712.614-.824 1.013-.278 1.964-.462 3.333-.462 2.212 0 4.357.555 6.038 1.561.306.175.445.414.445.771a.784.784 0 0 1-.782.785zm1.036-2.92c-.195 0-.315-.047-.495-.144-1.453-.872-3.72-1.391-6.069-1.391-1.224 0-2.336.135-3.306.397a2.072 2.072 0 0 0-.098.027 1.281 1.281 0 0 1-.365.068.914.914 0 0 1-.919-.929c0-.453.254-.799.68-.925 1.171-.346 2.519-.521 4.006-.521 2.678 0 5.226.595 6.991 1.631.332.189.495.475.495.872a.908.908 0 0 1-.92.915z" />
    </svg>
  );
}
